export default "__VITE_ASSET__CDJCO1hL__"